import { useParams, Outlet, Link as RouterLink } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { Container, Typography, Button } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'

import { queries } from '../../graphql'
import { LinearProgress } from '../../components'

export function ViewFund() {
  const { fundId } = useParams()

  const { data, loading, error } = useQuery(queries.funds.myFund, {
    variables: { fundId: parseInt(fundId, 10) },
    skip: !fundId,
  })

  const fund = data?.me?.fund

  if (loading) {
    return <LinearProgress />
  }

  if (error || !fund) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography color="error">{error ? `Error loading fund: ${error.message}` : 'Fund not found'}</Typography>
        <Button component={RouterLink} to="/funds" startIcon={<ArrowBack />} sx={{ mt: 2 }}>
          Back to Advisor Dashboard
        </Button>
      </Container>
    )
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Back Button */}
      <Button component={RouterLink} to="/funds" startIcon={<ArrowBack />} sx={{ mb: 3 }}>
        Back to Advisor Dashboard
      </Button>

      {/* Outlet for nested routes (activity, documents) */}
      <Outlet context={{ fund, fundId: parseInt(fundId, 10) }} />
    </Container>
  )
}
